import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  successFlag: false,
  error400: null,
  error: null,
  errorStatus: null,
  notifications: {},
  allNotifications: [],
  notification: null,
};
const getters = {
  getApiLoad_115: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_NotificationsList(state, data) {
    state.notifications = data;
  },
  SET_AllNotifications(state, data) {
    state.allNotifications = data;
  },
  SET_Notification(state, data) {
    state.notification = data;
  },
};
const actions = {
  errorNotifications({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllNotificationsDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/Notices/All', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_AllNotifications', response.data);
      })
      .catch((error) => {
        dispatch('errorNotifications', error);
      });
  },
  getAllActiveNotificationsDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/Notices/AllActive', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_AllNotifications', response.data);
      })
      .catch((error) => {
        dispatch('errorNotifications', error);
      });
  },
  getNotificationByIDDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/Notices/ByIdWithDetails', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_Notification', response.data);
      })
      .catch((error) => {
        dispatch('errorNotifications', error);
      });
  },
  addNewNotificationDispatch({ commit, dispatch, rootState }, body) {
    return apiClient
      .post('/Notices', body, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorNotifications', error);
      });
  },
  editNotificationDispatch({ commit, dispatch, rootState }, body) {
    return apiClient
      .post('/Notices/Edit', body, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorNotifications', error);
      });
  },
  activeNotificationDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .post(
        '/Notices/Activate',
        {},
        {
          params,
          headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorNotifications', error);
      });
  },
  deactiveNotificationDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .post(
        '/Notices/Deactivate',
        {},
        {
          params,
          headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorNotifications', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
